
//Custom Cells for Table compontent. Used by ObjectTable and SimpleTable. Note ES6
/*
The TableCell component is accessed via the CustomCell attribute on the columns prop.
If a custom cell is provided, the table will use that component to render each cell, giving it a value prop representing the attribute
from the datum for that row and index representing the (zero-indexed) row number. For more advanced use cases,
the rowDatum prop is also passed into the custom cell.

Note that sorting occurs on the actual data. Changing the presentation of the data does not affect the sort behavior.
*/

//HyperlinkCell is the original, but is hardcoded to reference a url prop. See class below for text to hyper
class HyperlinkCell extends React.Component {
    render() {
        const { rowDatum, value, getAriaLabel } = this.props;
        const ariaLabel = getAriaLabel?.(rowDatum);
        return (
          <TableCell>
              <a href={rowDatum.url} aria-label={ariaLabel}>{value}</a>
          </TableCell>
        );
    }
}

class StringToHyperlinkCell extends React.Component {
    render() {
        var oComponent = this;
        //this.props.index = row index, this.props.rowDatum = row data
        return (
          <TableCell>
              <a href={this.props.value}>{this.props.value}</a>
          </TableCell>
        );
    }
}

class FlagCell extends React.Component {
    render() {
        var state = this.props.value.state || "neutral";
        var flagClass = "flag--" + state;
        return (
          <TableCell>
              <span className={"flag " + flagClass}>{this.props.value.text}</span>
          </TableCell>
        );
    }
}

class EmailCell extends React.Component {
    render() {
        return (
          <TableCell>
              <a href={'mailto:'+this.props.value}>{this.props.value}</a>
          </TableCell>
        );
    }
}

class CollapsibleListCell extends React.Component {
    //Takes an array of single values
    constructor(props){
        super(props);
        this.collapsibleRef = React.createRef();
    }
    componentDidMount(){
        $(this.collapsibleRef.current).collapsible();
    }

    render() {
        let listItems = this.props.value.map(
            (item,index) => <li className="collection-item" key={"key_" + index}>{item}</li>
        )
        return (
            <TableCell>
                <div className="collapsible" ref={this.collapsibleRef}>
                    <button className="collapsible-header nowrap">Toggle List <Icon classes="icon-chevron-down icon--sm icon--disabled"></Icon></button>
                    <div className="collapsible-body">
                        <ul className="collection">{listItems}</ul>
                    </div>
                </div>
            </TableCell>
        );
    }
}

class ListCell extends React.Component {
    //Takes an array of single values
    render() {
        let listItems = this.props.value.map(
            (item,index) => <li className="collection-item" key={"key_" + index}>{item}</li>
        )
        return (
            <TableCell>
                <ul className="collection">{listItems}</ul>
            </TableCell>
        );
    }
}

class BulkFailureDetailsCell extends React.Component {
    //Takes an array of single values
    constructor(props){
        super(props);
        this.collapsibleRef = React.createRef();
    }
    componentDidMount(){
        $(this.collapsibleRef.current).collapsible();
    }

    render() {
        let listItems = this.props.value.map(
            (item,index) => <li className="collection-item" key={"key_" + index}><code>{item.email}</code> {item.failure}</li>
        )
        if(this.props.value.length > 0) {
            return (
                <TableCell>
                    <div className="collapsible" ref={this.collapsibleRef}>
                        <button className="collapsible-header nowrap">Details <Icon classes="icon-info-circle"></Icon></button>
                        <div className="collapsible-body">
                            <ul className="collection">{listItems}</ul>
                        </div>
                    </div>
                </TableCell>
            );
        } else {
            return (
                <TableCell><div className="collapsible" ref={this.collapsibleRef}></div></TableCell>
            );
        }

    }
}

class DateCell extends React.Component {
    render() {
        var oComponent = this;
        var dateString = "-";
        if(this.props.value != null) {
            dateString = fecha.format(new Date(this.props.value), 'MMM DD, YYYY');
        }
        //this.props.index = row index, this.props.rowDatum = row data
        return (
          <TableCell>{dateString}</TableCell>
        );
    }
}

class DateTimeCell extends React.Component {
    render() {
        var oComponent = this;
        var dateString = "-";
        if(this.props.value != null) {
            dateString = fecha.format(new Date(this.props.value), 'MMM DD, YYYY [at] hh:mm A');
        }
        //this.props.index = row index, this.props.rowDatum = row data
        return (
          <TableCell>{dateString}</TableCell>
        );
    }
}

class DateCellISO extends React.Component {
    render() {
        var oComponent = this;
        var dateString = "-";
        if(this.props.value != null) {
            dateString = this.props.value.split('T')[0];
        }
        //this.props.index = row index, this.props.rowDatum = row data
        return (
          <TableCell>{dateString}</TableCell>
        );
    }
}


class BooleanYesNoCell extends React.Component {
    render() {
        var oComponent = this;
        if(this.props.value == true){
            return (
              <TableCell>
                  <i className="icon-check icon--success"></i> Yes
              </TableCell>
            );
        } else {
            return (
              <TableCell><i className="icon-close icon--disabled"></i> No</TableCell>
            );
        }
    }
}

class BooleanIconCell extends React.Component {
    render() {
        var oComponent = this;
        if(this.props.value == true){
            return (
              <TableCell>
                  <i className="icon-check icon--success"></i>
              </TableCell>
            );
        } else {
            return (
              <TableCell><i className="icon-close icon--warning"></i></TableCell>
            );
        }
    }
}

class HasAssessmentURLCell extends React.Component {
    render() {
        var oComponent = this;
        //this.props.index = row index, this.props.rowDatum = row data
        // console.log(this.props.value);
        if(this.props.value != null){
            return (
              <TableCell>
                  <i className="icon-check icon--success"></i> Yes
              </TableCell>
            );
        } else {
            return (
              <TableCell><i className="icon-close"></i> Not Yet</TableCell>
            );
        }
    }
}

class RoleCell extends React.Component {
    render() {
        var oComponent = this;
        var role = this.props.value;
        role = role.replace("_", " ");
        return (
          <TableCell><span className="text--capitalize">{role}</span></TableCell>
        );
    }
}

class StatusCell extends React.Component {
    render() {
        var oComponent = this;
        return (
          <TableCell>{(function(){
            var data = oComponent.props.rowDatum;
            var status = data.status;
            var icon = (function() {
                switch(status) {
                    case "Published":
                        return "check icon--success";
                    case "Unpublished":
                        return "close";
                    case "Archived":
                        return "lock"
                }
            })

            return (<span><i className={"icon-" + icon()}></i> {status}</span>);
          })()}</TableCell>
        );
    }
}  

class AssertionStatusCell extends React.Component {
    render() {
        var oComponent = this;
        return (
          <TableCell>{(function(){
              if(oComponent.props.rowDatum.assertion != null && oComponent.props.rowDatum.criteria_earned > 0){
                  return(<span><i className="icon-check icon--success"></i> Yes</span>);
              } else if (oComponent.props.rowDatum.criteria_earned > 0){
                  return(<span><i className="icon-check"></i> Partial</span>);
              } else {
                  return(<span><i className="icon-close icon--warning"></i> Rejected</span>);
              }
          })()}</TableCell>
        );
    }
}

//expects prop value to be an object {} with badge properties
class BadgeCell extends React.Component {
    render() {
        var oComponent = this;
        var badge = this.props.value;
        return (
          <TableCell>
              <a href={badge.view_url}>{badge.name}</a> <a href={badge.url} target="_blank" className="flag flag--sm flag--muted">Raw Data</a> <BadgeDisc image={badge.image} name={badge.name} classes="float--right" />
          </TableCell>
        );
    }
}

function isOb3Badge(badge) {
    return badge.hasOwnProperty('format') && badge.format === "v3.0";
}

//Library has a slightly different appearance/behaviour
class BadgeLibraryCell extends React.Component {
    render() {
        var oComponent = this;
        var badge = this.props.rowDatum;
        let isOb3 = isOb3Badge(badge);
        let showImage = badge.image || (!badge.image && !isOb3);
        if(badge.grant){
            return (
              <TableCell>
                  <span title="Granted Badge" data-popover="tooltip"><Icon classes="icon-handshake-o"></Icon></span> <a href={badge.view_url}>{badge.name}</a> <BadgeDisc image={badge.image} name={badge.name} classes="float--right" />
              </TableCell>
            );
        } else {
            return (
              <TableCell>
                  <a href={badge.view_url}>{badge.name}</a> {showImage ? <BadgeDisc image={badge.image} name={badge.name} classes="float--right" /> : undefined}
              </TableCell>
            );
        }
    }
}    

//Library has a slightly different appearance/behaviour
class BadgeImportNameCell extends React.Component {
    constructor(props) {
        super(props);
        this.handlePreviewBadge = this.handlePreviewBadge.bind(this);
    }

    handlePreviewBadge() {
        //Build Modal
        httpGet(this.props.rowDatum.url).then(
            function(value) {
                var response = value;

                var $modal = buildModal(response,{
                    classes: 'modal modal--full',
                    header: "Badge Preview"
                });
                $('body').append($modal);
                $modal.on("modal:close",function(){
                    $modal.off("modal:close").remove();
                })
                $modal.openModal();
            })
        .catch(
            function(reason) {
                console.error('Error loading badge details.', reason);
                alertify.error('Unable to Badge Preview')
            });
    }

    render() {
        var oComponent = this;
        var badge = this.props.rowDatum;
        return (
            <TableCell>
                <a onClick={this.handlePreviewBadge}>{badge.name}</a> <BadgeDisc image={badge.image} name={badge.name} classes="float--right" />
            </TableCell>
        );
    }
}




class BadgeActionsCell extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        var oComponent = this;
        var badge = this.props.rowDatum;
        var isOb3 = isOb3Badge(badge);
        var isAwarded = badge.awardedCount > 0;
        var isArchived = badge.status === 'Archived';
        var isDisabled = isOb3 && (isAwarded || isArchived);
        if(badge.grant){
            return (
              <TableCell><Icon classes="icon-lock"></Icon> Grant</TableCell>
            );
        } else {
            return (
              <TableCell>
                  <a className={`button button--sm ${isDisabled ? 'disabled': ''}`} 
                  href={badge.edit_url} 
                  onClick={isDisabled ? (e) => e.preventDefault() : undefined}
                  {... isDisabled ? 
                    {
                        'data-popover': "tooltip",
                        'aria-disabled':"true", 
                        'title': isArchived ? 'Editing locked. Badge has been archived.' : 'Editing locked. Badge has been awarded.',
                    } : null}>Edit</a>
              </TableCell>
            );
        }

    }
}

class BadgeImportActionsCell extends React.Component {
    constructor(props) {
        super(props);
        this.handleImport = this.handleImport.bind(this);
    }
    handleImport() {
        var data = {
            badge: this.props.rowDatum.id
        };
        var route = buildRoute(mantlroutes.org_badges_import,{orgid: mantl.orgid});

        alertLoading("Importing Badge");
        httpPost(route, data).then(
            function(value){
                response = JSON.parse(value);
                removeLoading();
                alertify.success('Badge Imported!');
                setTimeout(function(){
                    window.location = response.edit_url;
                }, 250);
            })
        .catch(
            function(reason) {
                removeLoading();
                console.error(JSON.parse(reason));
                alertify.error("Unable to Import Badge");
            });
    }

    render() {
        var oComponent = this;
        var badge = this.props.rowDatum;
        return (
            <TableCell>
                <button className="button button--sm button--skinny" onClick={this.handleImport}>Import into Library</button>
            </TableCell>
        );

    }
}

class AssertionBadgeCell extends React.Component {
    render() {
        var oComponent = this;
        var badge = this.props.value;
        //this.props.index = row index, this.props.rowDatum = row data
        return (
          <TableCell>
              {badge.name}<BadgeDisc image={badge.image} name={badge.name} classes="float--right" />
          </TableCell>
        );
    }
}

class AssertionRevokedCell extends React.Component {
    render() {
        var oComponent = this;
        if(this.props.value != null) {
            dateString = fecha.format(new Date(this.props.value), 'MMM Do, YYYY');
        }
        //this.props.index = row index, this.props.rowDatum = row data
        return (
          <TableCell>
              {(function(){
                  if (oComponent.props.value == null) {
                    return (<span>No</span>);
                } else {
                    return (<p><b>{dateString}</b><br />{oComponent.props.rowDatum.reason}</p>);
                }
              })()}
          </TableCell>
        );
    }
}

class BadgeGrantActionsCell extends React.Component {
    constructor(props) {
        super(props);
        this.handleRevoke = this.handleRevoke.bind(this);
    }

    handleRevoke() {
        var oComponent = this;
        var data = {};
        var route = this.props.rowDatum.granted ? mantlroutes.org_badge_granted_grant : mantlroutes.org_badge_grants_grant;
        alertify.okBtn("Revoke Grant").cancelBtn("Cancel").confirm("<h1 class='h3'>Are you sure you want to revoke this badge grant?</h1>")
        .then(function (resolvedValue) {
            resolvedValue.event.preventDefault();
            if(resolvedValue.buttonClicked == "ok"){
                httpDelete(buildRoute(route, { orgid: mantl.orgid, grantid: oComponent.props.rowDatum.id })).then(
                    function(value){
                        alertify.log("Grant Revoked");
                        oComponent.props.rowDatum.store.onRefresh();
                    })
                .catch(
                    function(reason) {
                        alertify.error("Unable to revoke grant");
                    });
            }
        });
    }

    render() {
        return (
          <TableCell>
              <button className="button button--sm" onClick={this.handleRevoke}>Revoke</button>
          </TableCell>
        );
    }
}

class PrimaryOwnerCell extends React.Component {
    render() {
        var oComponent = this;
        var owner = this.props.value;
        //this.props.index = row index, this.props.rowDatum = row data
        return (
          <TableCell>
              <img src={owner.avatar} className="avatar" alt={owner.first_name + "'s Avatar"} /> <a href={'mailto:'+owner.email}>{owner.full_name}</a>
          </TableCell>
        );
    }
}

class EarnerCell extends React.Component {
    render() {
        var oComponent = this;
        var earner = this.props.value;
        //this.props.index = row index, this.props.rowDatum = row data
        return (
          <TableCell>
              {(function(){
                  if (earner.user == null) {
                    return (<span>{earner.first_name} {earner.last_name} <b>{earner.email}</b></span>);
                } else {
                    let portfolioURL = buildView(mantlroutes.portfolio_theirs, { portfolioid: earner.user.portfolio_id });
                    return (<a href={portfolioURL}><img src={earner.user.avatar} className="avatar" alt={earner.first_name + "'s Avatar"} /> {earner.user.full_name}</a>);
                }
              })()}

          </TableCell>
        );
    }
}

class UsernameCell extends React.Component {

    render() {
        var oComponent = this;
        var user = this.props.value;
        //this.props.index = row index, this.props.rowDatum = row data
        return (
          <TableCell>
              {(function(){
                if (user.portfolio_id == null) {
                    return (<span>{user.username}</span>);
                } else {
                    let portfolioURL = buildView(mantlroutes.portfolio_theirs, { portfolioid: user.portfolio_id });
                    return (<a href={portfolioURL}>{user.username}</a>);
                }
              })()}

          </TableCell>
        );
    }
}

class UserRoleCell extends React.Component {
    render() {
        var oComponent = this;
        var userrole = this.props.value;
        var userHome = buildView(mantlroutes.portfolio_theirs,{ portfolioid: userrole.user.portfolio_id });
        //this.props.index = row index, this.props.rowDatum = row data
        return (
          <TableCell>
              <img src={userrole.user.avatar} className="avatar" alt={userrole.user.first_name + "'s Avatar"} /> <a href={userHome}>{userrole.user.full_name}</a> <span className="flag flag--sm flag--muted"><ReadableRoleText role={userrole.role} ></ReadableRoleText></span>
          </TableCell>
        );
    }
}

//OrganizationCell expects a props value of an object {} container org properties
class OrganizationCell extends React.Component {
    render() {
        var oComponent = this;
        var org = this.props.value;
        var orgAbout = buildView(mantlroutes.org_about_view,{ orgid: org.id });
        return (
          <TableCell>
              <img src={org.image} className="badge-disc" alt={org.name + " Logo"} /> <a href={orgAbout}>{org.name}</a>
              <span className="enspace"></span>
          </TableCell>
        );
    }
}


//Issuer Cell is used in global dashboard
class IssuerCell extends React.Component {

    id_field = 'id';

    render() {
        var oComponent = this;
        var orgAbout = buildView(mantlroutes.org_about_view,{ orgid: oComponent.props.rowDatum[oComponent.id_field] });
        //this.props.index = row index, this.props.rowDatum = row data
        return (
          <TableCell>
              <a href={orgAbout}>{this.props.value}</a>
          </TableCell>
        );
    }
}


class InstitutionCell extends IssuerCell {

    id_field = 'parent_org_id';

}


class AssessmentActionsCell extends React.Component {

    constructor(props) {
        super(props);
        this.handleViewAssessment = this.handleViewAssessment.bind(this);
    }

    handleViewAssessment() {
        var oComponent = this;
        var data = {};
        httpGet(this.props.rowDatum.assessment_url).then(
            function(value) {
                var response = JSON.parse(value);
                data.assessment = response;
                //Get the submission as well, put it into the modal
                httpGet(oComponent.props.rowDatum.submission_url).then(
                    function(value) {
                        var submission = JSON.parse(value);
                        data.submission = submission;

                        httpGet(submission.badge.url).then(
                            function(value) {
                                var badge = JSON.parse(value);
                                data.badge = badge;

                                var hbstemplate = mantlhbs.program.assessment;
                                var output = hbstemplate(data);

                                var $modal = buildModal(output,{
                                    classes: 'modal modal--full modal--flat',
                                    header: 'Program Assessment'
                                });
                                $('body').append($modal);
                                $modal.on("modal:close",function(){
                                    $modal.off("modal:close").remove();
                                })
                                ParseMarkdown();
                                $modal.openModal();

                            }
                        );

                    });
            })
        .catch(
            function(reason) {
                console.error('Error loading assessment.', reason);
                alertify.error('Unable to load assessment.')
            });
    }

    render() {
        var oComponent = this;
        return (
          <TableCell>
              <button type="button" className="button--sm" onClick={oComponent.handleViewAssessment}>View Assessment</button>
          </TableCell>
        );
    }
}



class SubmissionActionsCell extends React.Component {

    constructor(props) {
        super(props);
        this.handleViewSubmission = this.handleViewSubmission.bind(this);
        this.handleViewAssessment = this.handleViewAssessment.bind(this);
        this.handleModalAssess = this.handleModalAssess.bind(this);
        this.handleStartAssess = this.handleStartAssess.bind(this);
    }

    handleViewSubmission() {
        httpGet(this.props.rowDatum.submission_url).then(
            function(value) {
                var response = JSON.parse(value);
                var data = {
                    submission: response
                }

                httpGet(response.badge.url).then(
                    function(value) {
                        var badge = JSON.parse(value);
                        data.badge = badge;
                        console.log(data);
                        var hbstemplate = mantlhbs.program.submission;
                        var output = hbstemplate(data);

                        var $modal = buildModal(output,{
                            classes: 'modal modal--full modal--flat',
                            header: 'Program Submission'
                        });
                        $('body').append($modal);
                        $modal.on("modal:close",function(){
                            $modal.off("modal:close").remove();
                        })
                        $modal.openModal();

                    }
                );

            })
        .catch(
            function(reason) {
                console.error('Error loading submission.', reason);
                alertify.error('Unable to load submission.')
            });
    }

    handleViewAssessment() {
        var oComponent = this;
        var data = {};
        httpGet(this.props.rowDatum.assessment_url).then(
            function(value) {
                var response = JSON.parse(value);
                data.assessment = response;
                //Get the submission as well, put it into the modal
                httpGet(oComponent.props.rowDatum.submission_url).then(
                    function(value) {
                        var submission = JSON.parse(value);
                        data.submission = submission;

                        httpGet(submission.badge.url).then(
                            function(value) {
                                var badge = JSON.parse(value);
                                data.badge = badge;

                                var hbstemplate = mantlhbs.program.assessment;
                                var output = hbstemplate(data);

                                var $modal = buildModal(output,{
                                    classes: 'modal modal--full modal--flat',
                                    header: 'Program Assessment'
                                });
                                $('body').append($modal);
                                $modal.on("modal:close",function(){
                                    $modal.off("modal:close").remove();
                                })
                                $modal.openModal();

                            }
                        );

                    });
            })
        .catch(
            function(reason) {
                console.error('Error loading assessment.', reason);
                alertify.error('Unable to load assessment.')
            });
    }

    handleModalAssess() {
        var oComponent = this;
        var assessURL = buildView(mantlroutes.program_assess, { orgid: mantl.orgid, programid: mantl.programid, submissionid: this.props.rowDatum.id });

        httpGet(assessURL).then(
            function(value) {
                console.log(value);
            })
        .catch(
            function(reason) {
                console.error('Error loading assessment.', reason);
                alertify.error('Unable to load assessment.')
            });
    }

    handleStartAssess() {
        var oComponent = this;
        var assessURL = buildView(mantlroutes.program_assess, { orgid: mantl.orgid, programid: mantl.programid, submissionid: this.props.rowDatum.id });

        httpGet(assessURL).then(
            function(value) {
                window.location = assessURL;
            })
        .catch(
            function(reason) {
                alertify.error('Unable to start assessment.')
            });
    }

    render() {
        var oComponent = this;
        var assessURL = buildView(mantlroutes.program_assess, { orgid: mantl.orgid, programid: mantl.programid, submissionid: this.props.rowDatum.id });
        // console.log(this.props.rowDatum);
        var [role_index, program_role] = this.props.rowDatum.actions;
        if(this.props.rowDatum.assessment_url != null){
            //Has been assessed
            return (
              <TableCell>
                  <button type="button" className="button--sm" onClick={oComponent.handleViewAssessment}>View Assessment</button>
              </TableCell>
            );
        } else {
            return (
              <TableCell>
                  <button type="button" className="button--sm" onClick={oComponent.handleViewSubmission}>View</button>&nbsp;
                  {/* <button type="button" className="button--sm" onClick={oComponent.handleModalAssess}>Assess Modal</button>&nbsp; */}
                  {/* <a className="button button--sm" href={assessURL}>Assess</a> */}
                  { role_index == 0 || program_role != null && role_index < 4 ?
                  <a className="button button--sm" onClick={oComponent.handleStartAssess}>Assess</a> :
                  <a className="button button--sm" disabled onClick={e => e.preventDefault()}>Assess</a>}
              </TableCell>
            );
        }
    }
}


class LearnerActiveCell extends React.Component {
    constructor(props) {
        super(props);
        this.handleSwitch = this.handleSwitch.bind(this);
    }

    handleSwitch(bIsOn){
        var oComponent = this;
        //console.log("switched", bIsOn)
        var data = {
            "active": bIsOn
        }

        httpPatch(buildRoute(mantlroutes.program_learners_item, { orgid: mantl.orgid, programid: mantl.programid, userid: this.props.rowDatum.id }), data).then(
            function(value){
                var oResponse = JSON.parse(value);
                alertify.success("Program status updated.");
                oComponent.props.rowDatum.store.onRefresh();
            })
        .catch(
            function(reason) {
                alertify.error("Unable to change program status.");
            });
    }

    componentDidMount() {
        var oComponent = this;
        var $cell = $(ReactDOM.findDOMNode(this));
        if(oComponent.props.rowDatum.can_change_active) {
            $cell.on('change','.switch',function(){
                var bIsOn = $(this).prop( "checked" );
                oComponent.handleSwitch(bIsOn);
            });
        } else {
            $cell.find('.switch').attr("disabled","disabled");
        }
    }

    render() {
        var oComponent = this;
        var prefix = "active_";
        if(!oComponent.props.value) {
            prefix = "inactive_";
        }
        var checkbox = prefix + oComponent.props.rowDatum.id;
        //this.props.index = row index, this.props.rowDatum = row data
        return (
          <TableCell>
              {(function(){
                  if (oComponent.props.value) {
                    return (<span><input type="checkbox" id={checkbox} className="switch switch--small" defaultChecked aria-hidden="false" /><label htmlFor={checkbox} className="switch-label" data-popover="tooltip" data-delay="750" title="Active Member">ActiveProgram Member</label></span>);
                } else {
                    return (<span><input type="checkbox" id={checkbox} className="switch switch--small" aria-hidden="false" /><label htmlFor={checkbox} className="switch-label" data-popover="tooltip" data-delay="750" title="Active Member">Active Program Member</label></span>);
                }
              })()}
          </TableCell>
        );
    }
}

//TODO Make this not terrible with poor patterns, ids etc

class LearnerProgressCell extends React.Component {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick(){
        var oComponent = this;
        var $modal = buildModal("<div id='learnerProgramExplorer'></div>",{
            classes: 'modal modal--full',
            header: htmlEncode(this.props.rowDatum.first_name) + "'s Program Progress"
        });
        console.log(oComponent.props.rowDatum)
        $('body').append($modal);
        $modal.on("modal:open",function(){
            myProgram = new ProgramExplorer({
                programID: mantl.programid,
                orgID: mantl.orgid,
                program_role_id: oComponent.props.rowDatum.program_role_id,
                view_mode: true
            });
            myProgram.renderItems('learnerProgramExplorer');
        })
        $modal.on("modal:close",function(){
            $modal.off("modal:close").remove();
            myProgram = null;
        })
        $modal.openModal();

    }

    componentDidMount() {
        var oComponent = this;
    }

    render() {
        var oComponent = this;
        //this.props.index = row index, this.props.rowDatum = row data
        return (
          <TableCell>
              <a onClick={this.handleClick} title="View Program Progress">{oComponent.props.value}</a>
          </TableCell>
        );
    }
}

class StaffCanAssertCell extends React.Component {
    render() {
        var oComponent = this;
        //this.props.index = row index, this.props.rowDatum = row data
        return (
          <TableCell>
              {(function(){
                  if (oComponent.props.value) {
                    return (<i className="icon-check icon--success" title="Can Assert"></i>);
                } else {
                    return (<i className="icon-close" title="Can't Assert"></i>);
                }
              })()}
          </TableCell>
        );
    }
}

//Cell needs to also know if it can be changed
class StaffCanEditCell extends React.Component {
    constructor(props) {
        super(props);
        this.handleSwitch = this.handleSwitch.bind(this);
    }

    handleSwitch(bIsOn){
        var oComponent = this;
        //console.log("switched", bIsOn)
        var data = {
            "can_edit": bIsOn
        }

        httpPatch(buildRoute(mantlroutes.program_staff_item, { orgid: mantl.orgid, programid: mantl.programid, userid: this.props.rowDatum.id }), data).then(
            function(value){
                var oResponse = JSON.parse(value);
                alertify.success("Program staff updated.");
                oComponent.props.rowDatum.store.onRefresh();
            })
        .catch(
            function(reason) {
                alertify.error("Unable to change Can Edit.");
            });
    }

    componentDidMount() {
        var oComponent = this;
        var $cell = $(ReactDOM.findDOMNode(this));
        if(oComponent.props.rowDatum.can_change_edit) {
            $cell.on('change','.switch',function(){
                var bIsOn = $(this).prop( "checked" );
                oComponent.handleSwitch(bIsOn);
            });
        } else {
            $cell.find('.switch').attr("disabled","disabled");
        }
    }

    render() {
        var oComponent = this;
        var prefix = "staff_";
        var checkbox = prefix + oComponent.props.rowDatum.id;
        //this.props.index = row index, this.props.rowDatum = row data
        return (
          <TableCell>
              {(function(){
                  if (oComponent.props.value) {
                    return (<span><input type="checkbox" id={checkbox} className="switch switch--small" defaultChecked aria-hidden="false" /><label htmlFor={checkbox} className="switch-label" title="Can Edit Program">Can Edit</label></span>);
                } else {
                    return (<span><input type="checkbox" id={checkbox} className="switch switch--small" aria-hidden="false" /><label htmlFor={checkbox} className="switch-label" title="Can Edit Program">Can Edit</label></span>);
                }
              })()}
          </TableCell>
        );
    }
}

class StaffActionsCell extends React.Component {
    constructor(props) {
        super(props);
        this.handleRemove = this.handleRemove.bind(this);
    }

    handleRemove(){
        var oComponent = this;

        alertify.okBtn("Remove Staff").cancelBtn("Cancel").confirm("<h1 class='h3'>Are you sure you want to remove this staff member?</h1><p class='text--danger'><i class='icon-warning'></i> Any assessments made by this staff member will be deleted.</p>")
        .then(function (resolvedValue) {
            resolvedValue.event.preventDefault();
            if(resolvedValue.buttonClicked == "ok"){
                httpDelete(buildRoute(mantlroutes.program_staff_item, { orgid: mantl.orgid, programid: mantl.programid, userid: this.props.rowDatum.id })).then(
                    function(value){
                        alertify.log("Program staff member removed.");
                        oComponent.props.rowDatum.store.onRefresh();
                    })
                .catch(
                    function(reason) {
                        alertify.error("Unable to remove staff member.");
                    });
            } else {
                // alertify.log("Removal Cancelled")
            }

        });



    }

    componentDidMount() {
    }

    render() {
        var oComponent = this;
        //this.props.index = row index, this.props.rowDatum = row data
        if(this.props.rowDatum.can_remove){
            //Has been assessed
            return (
              <TableCell>
                  <button type="button" className="button--sm button--skinny" onClick={this.handleRemove}>Remove</button>
              </TableCell>
            );
        } else {
            return (
              <span><i className="icon-lock"></i></span>
            );
        }
    }
}

class OrgStaffActionsCell extends React.Component {
    constructor(props) {
        super(props);
        this.handleEarnerLimit = this.handleEarnerLimit.bind(this);
        this.handleAPIToggle = this.handleAPIToggle.bind(this);
        this.handleLTIToggle = this.handleLTIToggle.bind(this);
        this.handleVerifyToggle = this.handleVerifyToggle.bind(this);
    }

    handleEarnerLimit(){
        var oComponent = this;
        alertify
        .defaultValue(oComponent.props.rowDatum.max_monthly_earners.toString())
        .prompt("Set New Max Monthly Earners for " + oComponent.props.rowDatum.name,
        function (val, ev) {
            ev.preventDefault();
            // The value entered is availble in the val variable.
            var newVal = parseInt(val);
            if (Number.isInteger(newVal) && newVal > 49) {
                httpPatch(buildRoute(mantlroutes.org_about,{orgid: oComponent.props.rowDatum.id}), { max_monthly_earners: newVal }).then(
                    function(value){
                        // response = JSON.parse(value);
                        // console.log(response);
                        alertify.success('Earner Limit Updated');
                        oComponent.props.rowDatum.store.onRefresh();
                    })
                .catch(
                    function(reason) {
                        alertify.error('Unable to Update Limit');
                    });

            } else {
                alertify.error("Value must be a number of 50 or greater.");
            }
        }, function(ev) {
            ev.preventDefault();
            alertify.error("Cancelled Limit Change");
        });

    }

    handleAPIToggle(){
        var oComponent = this;
        var newVal = !oComponent.props.rowDatum.api_enabled;
        httpPatch(buildRoute(mantlroutes.org_about,{orgid: oComponent.props.rowDatum.id}), { api_enabled: newVal }).then(
            function(value){
                alertify.success('API Access Updated');
                oComponent.props.rowDatum.store.onRefresh();
            })
        .catch(
            function(reason) {
                alertify.error('Error Updating API Access');
            });
    }

    handleLTIToggle() {
        var oComponent = this;
        var newVal = !oComponent.props.rowDatum.lti_enabled;
        httpPatch(buildRoute(mantlroutes.org_about,{orgid: oComponent.props.rowDatum.id}), { lti_enabled: newVal }).then(
            function(value){
                alertify.success('LTI Access Updated');
                oComponent.props.rowDatum.store.onRefresh();
            })
        .catch(
            function(reason) {
                alertify.error('Error Updating LTI Access');
            });
    }

    componentDidMount() {
    }

    render() {
        var oComponent = this;
        var apiSlug = (this.props.rowDatum.api_enabled) ? "No" : "Add";
        var ltiSlug = (this.props.rowDatum.lti_enabled) ? "No" : "Add";
        var memberMetricsUrl = buildView(mantlroutes.org_view_member_metrics, { orgid: this.props.rowDatum.id });

        //this.props.index = row index, this.props.rowDatum = row data
        return (
            <TableCell>
                <div className="dropdown">
                    <button className="dropdown-toggle button--flat button--sm button--skinny" id={"actions_" + oComponent.props.rowDatum.id} data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><Icon classes="icon-ellipsis-h" title="Open Menu" /></button>

                    <div className="dropdown-menu dropdown-menu-right" aria-labelledby={"actions_" + oComponent.props.rowDatum.id}>
                        <a href={memberMetricsUrl} target="_blank" className="dropdown-item">View Members</a>
                        {/* <button type="button" className="dropdown-item" onClick={this.handleEarnerLimit}>Edit Limit</button> */}
                        <button type="button" className="dropdown-item" onClick={this.handleAPIToggle}>{apiSlug} API</button>
                        <button type="button" className="dropdown-item" onClick={this.handleLTIToggle}>{ltiSlug} LTI</button>
                    </div>
                </div>
            </TableCell>
        );
    }
}

class OrgMemberActionsCell extends React.Component {
    constructor(props) {
        super(props);
        this.handleRoleChange = this.handleRoleChange.bind(this);
        this.handleToOwner = this.handleToOwner.bind(this);
        this.handleToAdmin = this.handleToAdmin.bind(this);
        this.handleToMember = this.handleToMember.bind(this);
        this.handleToMentor = this.handleToMentor.bind(this);
        this.handleToActive = this.handleToActive.bind(this);
        this.handleToInactive = this.handleToInactive.bind(this);
        this.handleToDeleted = this.handleToDeleted.bind(this);
        this.handleConfirmDeleted = this.handleConfirmDeleted.bind(this);
    }

    handleRoleChange(newRole) {
        var oComponent = this;
        var userID = this.props.rowDatum.id;
        var full_name = this.props.rowDatum.full_name;
        var data = {};
        if(newRole == "active"){
            data = {
                active: true
            }
        } else if (newRole == "inactive"){
            data = {
                active: false
            }
        } else {
            data = {
                role: newRole
            }
        }

        httpPatch(buildRoute(mantlroutes.org_member,{orgid: mantl.orgid, userid: userID}), data).then(
            function(value){
                response = JSON.parse(value);
                console.log(response);
                alertify.success(htmlEncode(full_name) + ' Updated');
                //refresh member tables
                if(typeof(memberTable) != "undefined"){
                    memberTable.Actions.refresh();
                }
                if(typeof(mentorTable) != "undefined"){
                    mentorTable.Actions.refresh();
                }
                if(typeof(learnerTable) != "undefined"){
                    learnerTable.Actions.refresh();
                }
                if(typeof(guestTable) != "undefined"){
                    guestTable.Actions.refresh();
                }
                if(typeof(inactiveTable) != "undefined"){
                    inactiveTable.Actions.refresh();
                }
            })
        .catch(
            function(reason) {
                alertify.error('Unable to Update User');
            });
    }

    handleToOwner() {
        this.handleRoleChange("owner")
    }
    handleToAdmin() {
        this.handleRoleChange("admin")
    }
    handleToMember() {
        this.handleRoleChange("member")
    }
    handleToMentor() {
        this.handleRoleChange("mentor")
    }
    handleToActive() {
        this.handleRoleChange("active")
    }
    handleToInactive() {
        this.handleRoleChange("inactive")
    }

    handleToDeleted() {
        var _self = this;
        var userID = this.props.rowDatum.id;
        httpGet(buildRoute(mantlroutes.programs_allroles,{orgid: mantl.orgid, userid: userID})).then(
            function(value){
                response = JSON.parse(value);
                _self.handleConfirmDeleted(response);
            })
        .catch(
            function(reason) {
                alertify.error('Unable to Get Program Role List');
            });
    }

    handleConfirmDeleted(roles) {
        var _self = this;
        var userID = this.props.rowDatum.id;
        var data = {
            role: this.props.rowDatum.role,
            full_name: htmlEncode(this.props.rowDatum.full_name),
            roles: roles
        }
        var hbstemplate = mantlhbs.member.confirmdelete;
        var output = hbstemplate(data);
        var endpoint = buildRoute(mantlroutes.org_member,{orgid: mantl.orgid, userid: userID});
        alertify.okBtn("Yes, Delete").okStyle('button--danger').cancelBtn("Cancel").confirm(output)
        .then(function (resolvedValue) {
            resolvedValue.event.preventDefault();
            if(resolvedValue.buttonClicked == "ok"){
                httpDelete(endpoint).then(
                    function(value){
                        alertify.log("Deleted " + htmlEncode(data.full_name))
                        _self.props.rowDatum.store.onRefresh();
                    })
                .catch(
                    function(reason) {
                        console.error(reason);
                        alertify.error("Unable to delete member.");
                    });

            } else {
                alertify.log("Cancelled")
            }
        });
    }

    render() {
        var oComponent = this;
        var role_map = this.props.rowDatum.role + "_to";
        var can_i_change = this.props.rowDatum.actions;
        var can_change_to = {
            primary_owner: false, //done in a different UI
            owner: can_i_change[role_map].owner === true,
            admin: can_i_change[role_map].admin === true,
            member: can_i_change[role_map].member === true,
            mentor: can_i_change[role_map].mentor === true,
            active: can_i_change[role_map].active === true,
            inactive: can_i_change[role_map].inactive === true,
            deleted: can_i_change[role_map].deleted === true
        };

        if (can_change_to.owner || can_change_to.admin || can_change_to.member || can_change_to.mentor || can_change_to.active && ! this.props.rowDatum.active || can_change_to.inactive && this.props.rowDatum.active) {
            return (
                <TableCell>
                        <div className="dropdown">
                            <button className="button--sm dropdown-toggle button--skinny" id={"actions_" + oComponent.props.rowDatum.id} data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">User Actions <i className="icon-caret-down"></i></button>

                            <div className="dropdown-menu" aria-labelledby={"actions_" + oComponent.props.rowDatum.id}>

                              {(function(){
                                  if (can_change_to.owner && oComponent.props.rowDatum.active) {
                                      return (<button className="dropdown-item" onClick={oComponent.handleToOwner}>Make Owner</button>);
                                  }
                              })()}
                              {(function(){
                                  if (can_change_to.admin && oComponent.props.rowDatum.active) {
                                      return (<button className="dropdown-item" onClick={oComponent.handleToAdmin}>Make Admin</button>);
                                  }
                              })()}
                              {(function(){
                                  if (can_change_to.member && oComponent.props.rowDatum.active) {
                                      return (<button className="dropdown-item" onClick={oComponent.handleToMember}>Make Member</button>);
                                  }
                              })()}
                              {(function(){
                                  if (can_change_to.mentor && oComponent.props.rowDatum.active) {
                                      return (<button className="dropdown-item" onClick={oComponent.handleToMentor}>Make Mentor</button>);
                                  }
                              })()}
                              {(function(){
                                  if (can_change_to.active && !oComponent.props.rowDatum.active) {
                                      return (<button className="dropdown-item" onClick={oComponent.handleToActive}>Make Active</button>);
                                  }
                              })()}
                              {(function(){
                                  if (can_change_to.inactive && oComponent.props.rowDatum.active) {
                                      return (<button className="dropdown-item text--danger" onClick={oComponent.handleToInactive}>Retire User</button>);
                                  }
                              })()}
                              {(function(){
                                  if (can_change_to.deleted) {
                                      return (<button className="dropdown-item text--danger" onClick={oComponent.handleToDeleted}><Icon classes="icon-warning"></Icon> Delete User</button>);
                                  }
                              })()}
                          </div>
                        </div>
                </TableCell>
            );

        } else {
            return (
                <TableCell></TableCell>
            );
        }


    }
}


class OrgInvitationActionsCell extends React.Component {
    constructor(props) {
        super(props);
        this.handleDelete = this.handleDelete.bind(this);
        this.handleUpdate = this.handleUpdate.bind(this);
    }

    handleDelete(newRole) {
        var oComponent = this;
        console.log('handle')

        var invitationID = this.props.rowDatum.id;

        alertify.okBtn("Cancel Invitation").cancelBtn("Go Back").confirm("<h1 class='h3'>Are you sure you want to cancel this invitation?</h1>")
        .then(function (resolvedValue) {
            resolvedValue.event.preventDefault();
            if(resolvedValue.buttonClicked == "ok"){
                httpDelete( buildRoute(mantlroutes.org_invitation, { orgid: mantl.orgid, invitationid: invitationID }) ).then(
                    function(value){
                        alertify.success('Invitation Deleted');
                        if(typeof(invitationsTable) != "undefined"){
                            invitationsTable.Actions.refresh(); //global variable invitationsTable from org invitation table
                        }
                    })
                .catch(
                    function(reason) {
                        alertify.error('Unable to Delete Invitation');
                    });

            } else {
                alertify.log("Invitation Delete Cancelled")
            }

        });
    }

    handleUpdate() {
        var oComponent = this;
        console.log('handle')
    }

    render() {
        var oComponent = this;
        //this.props.index = row index, this.props.rowDatum = row data

        if(this.props.rowDatum.date_completed == null){
            return (
                <TableCell><button className="button button--sm button--skinny button--bordered border--primary" onClick={oComponent.handleDelete}><i className='icon-close icon--error'></i> Cancel</button></TableCell>
            );
        } else {
            return (
                <TableCell></TableCell>
            );
        }


    }
}

class OrgInvitationEmailCell extends React.Component {
    render() {
        var oComponent = this;
        //this.props.index = row index, this.props.rowDatum = row data
        if(this.props.value == true){
            //email sent
            return (
                <TableCell><i className='icon-check icon--success'></i> Sent</TableCell>
            );
        } else {
            //email not sent
            return (
                <TableCell><i className='icon-close icon--error'></i> Failed to Send</TableCell>
            );
        }

    }
}

class OrgMembershipsCell extends React.Component {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick() {
        var oComponent = this;
        var data = this.props.value;
        var hbstemplate = mantlhbs.user.memberships;
        var output = hbstemplate(data);

        var $modal = buildModal(output,{
            classes: 'modal modal--large modal--flat',
            header: 'Memberships'
        });
        $('body').append($modal);
        $modal.on("modal:close",function(){
            $modal.off("modal:close").remove();
        })
        $modal.openModal();
    }

    componentDidMount() {

    }

    render() {
        var memberships = this.props.value;
        //this.props.index = row index, this.props.rowDatum = row data
        if(memberships.length > 0){
            return (
                <TableCell>
                    <Icon classes="icon-user"></Icon> {memberships.length} <button className="button--skinny button--flat button--sm text--secondary" onClick={this.handleClick}>View</button>
                </TableCell>
              );
        } else {
            return (
                <TableCell><Icon classes="icon-user"></Icon> {memberships.length}</TableCell>
              );
        }

    }
}

class ProgramMembershipsCell extends React.Component {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick() {
        var oComponent = this;
        var data = this.props.value;
        var hbstemplate = mantlhbs.user.program.memberships;
        var output = hbstemplate(data);

        var $modal = buildModal(output,{
            classes: 'modal modal--large modal--flat',
            header: 'Memberships'
        });
        $('body').append($modal);
        $modal.on("modal:close",function(){
            $modal.off("modal:close").remove();
        })
        $modal.openModal();
    }

    render() {
        var memberships = this.props.value;
        //this.props.index = row index, this.props.rowDatum = row data
        if(memberships.length > 0){
            return (
                <TableCell>
                    <Icon classes="icon-cubes"></Icon> {memberships.length} <button className="button--skinny button--flat button--sm text--secondary" onClick={this.handleClick}>View</button>
                </TableCell>
              );
        } else {
            return (
                <TableCell><Icon classes="icon-cubes"></Icon> {memberships.length}</TableCell>
              );
        }

    }
}
